<template>
  <div class="stydyDetails">
    <div class="page_header">
      <div class="page_header_left" @click="goBack">
        <i class="el-icon-back"></i>
        <div class="page_header_left_back">返回</div>
        <div class="page_header_content">练习详情</div>
      </div>
      <div class="mwow-button info" @click="delHomeWork(detailsData)">删除</div>
    </div>
    <el-row class="page_content">
      <div class="contertTop">
        <h1>练习要求</h1>
        <el-row>
          <el-col :span="8">
            <div style="margin-top: 20px" class="contentNmne">
              练习名称：{{ detailsData.title }}
            </div>
          </el-col>
        </el-row>
        <el-row class="conterDetails">
          <el-col :span="8">
            <div class="contentNmne">
              发布类型：{{ detailsData.type == 1 ? "学员类" : "课次类" }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="contentNmne">
              发布时间：{{
                !!detailsData.publish_time
                  ? setTime(detailsData.publish_time)
                  : ""
              }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="contentNmne">
              截止时间：{{
                !!detailsData.deadline_time
                  ? setTime(detailsData.deadline_time)
                  : ""
              }}
            </div>
          </el-col>
        </el-row>
        <div class="time-line-switch">
          <div class="p4" @click="showFormSearch = !showFormSearch">
            {{ showFormSearch ? "收起" : "展开" }}
            <span
              :class="
                showFormSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></span>
          </div>
        </div>
      </div>
      <div v-show="showFormSearch">
        <div v-if="detailsData.content_list.length > 0">
          <div class="practice-classification" v-if="showText">
            <div class="title" style="padding-top: 15px">文案:</div>
            <div class="contertBottom contertBottom-right">
              <template v-for="(item, index) in detailsData.content_list">
                <div
                  v-html="item.annex_content.replace(/\n/g, '<br/>')"
                  class="center"
                  v-if="item.annex_type == 3"
                  :key="index"
                ></div>
              </template>
            </div>
          </div>
          <div class="practice-classification" v-if="showPicture">
            <div class="title">图片:</div>
            <div class="contertBottom contertBottom-right">
              <template v-for="(item, index) in detailsData.content_list">
                <div class="imgVideo" :key="index" v-if="item.annex_type == 1">
                  <div class="imgbox" @click="newOpen(item.annex_content)">
                    <img :src="item.annex_content" alt="" />
                    <i class="el-icon-zoom-in big"></i>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="practice-classification" v-if="showMP3">
            <div class="title">音频:</div>
            <div class="contertBottom contertBottom-right">
              <div class="audiobox" v-if="detailsData.audioList">
                <div
                  v-for="(item, index) in detailsData.audioList"
                  :key="index"
                  class="audiosmbox"
                >
                  <audioPlay :audioItem="item"></audioPlay>
                </div>
              </div>
            </div>
          </div>
          <div class="practice-classification" v-if="showMP4">
            <div class="title">视频:</div>
            <div class="contertBottom contertBottom-right">
              <template v-for="(item, index) in detailsData.content_list">
                <div class="imgVideo" :key="index" v-if="item.annex_type == 2">
                  <div class="videobox" @click="newOpen(item.annex_content)">
                    <video :src="item.annex_content"></video>
                    <i class="el-icon-zoom-in big"></i>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!-- 曲谱 -->
          <div class="practice-classification" v-if="showSheet">
            <div class="title">曲谱:</div>
            <div class="contertBottom contertBottom-right">
              <template v-for="(item, index) in detailsData.content_list">
                <div :key="index" v-if="item.annex_type == 5">
                  <div class="opernbox">
                    <div class="flex opern-title">
                      <div class="title-text">{{ item.music.name }}</div>
                    </div>
                    <div class="flex opern-content">
                      <div class="flex content-info">
                        <div class="flex">
                          <span>{{
                            item.music.instrument_list
                              .map((it) => {
                                return it.name;
                              })
                              .join(",") || "-"
                          }}</span>
                        </div>
                        <div class="content-border"></div>
                        <div class="flex">
                          <span>{{
                            item.music.singer_list
                              .map((it) => {
                                return it.name;
                              })
                              .join(",") || "-"
                          }}</span>
                        </div>
                        <div
                          class="content-border"
                          v-show="item.music.tonality"
                        ></div>
                        <div v-show="item.music.tonality">
                          {{ item.music.tonality }}
                        </div>
                      </div>
                      <div
                        class="content-view"
                        @click="handleSheetPreview(item)"
                      >
                        预览
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <div class="page_footer">
      <h1>练习明细</h1>
      <el-form
        style="margin-top: 15px"
        size="mini"
        ref="form"
        :model="searchInfo"
        inline
      >
        <el-form-item label="练习状态:" prop="status">
          <el-select
            v-model="searchInfo.status"
            filterable
            clearable
            multiple
            placeholder="请选择"
            @change="handleRefresh"
          >
            <el-option
              v-for="item in statusList"
              :key="item.status_id"
              :label="item.name"
              :value="item.status_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        v-horizontal-scroll
        :data="tableData"
        size="mini"
        tooltip-effect="dark"
        style="width: 100%"
        stripe
        :default-sort="{ prop: 'committed_time', order: 'descending' }"
        @sort-change="clickStort"
      >
        <el-table-column label="学员姓名" prop="student.name">
        </el-table-column>
        <el-table-column label="练习状态" prop="status">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1" class="mwow-red">未发布</div>
            <div
              v-else-if="
                scope.row.deadline_status === 2 && scope.row.status === 2
              "
              class="mwow-red"
            >
              未提交
            </div>
            <div v-else-if="scope.row.status === 3" class="mwow-yellow">
              待批改
            </div>
            <div v-else-if="scope.row.status === 4" class="mwow-green">
              已批改
            </div>
            <div
              v-else-if="
                scope.row.deadline_status === 1 && scope.row.status === 2
              "
              class="mwow-gray"
            >
              已截止
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          label="提交时间"
          prop="committed_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column label="批改人员" prop="corrected_staff">
          <template slot-scope="scope">
            <div v-if="scope.row.corrected_staff !== null">
              {{ scope.row.corrected_staff.name }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="批改时间" prop="corrected_time">
        </el-table-column>
        <el-table-column label="练习评星" prop="teacher_answer">
          <template slot-scope="scope">
            <div v-if="scope.row.teacher_answer !== null">
              {{ scope.row.teacher_answer.star_num }} 星
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="练习评语" prop="teacher_answer">
          <template slot-scope="scope">
            <div v-if="scope.row.teacher_answer !== null">
              {{ scope.row.teacher_answer.content }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 3 || scope.row.status === 4">
              <span class="cu-po" @click="correct(scope.row)">{{
                scope.row.status === 3 ? "批改" : "详情"
              }}</span>
              <span
                class="cu-po"
                @click="republish(scope.row)"
                v-if="scope.row.status === 4 && scope.row.deadline_status === 2"
              >
                | 重发</span
              >
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
      <img class="bigimg" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVideo"
      :modal-append-to-body="false"
      destroy-on-close
    >
      <video :src="dialogVideoUrl" class="bigimg" controls></video>
    </el-dialog>
    <el-dialog
      :visible.sync="showCorrectDialog"
      :modal-append-to-body="false"
      destroy-on-close
      title="练习详情"
      :close-on-click-modal="false"
    >
      <correct-dialog
        :origin-data="correctDialogInfo"
        v-if="showCorrectDialog"
        @close="
          () => {
            handleRefresh();
            showCorrectDialog = false;
          }
        "
      ></correct-dialog>
    </el-dialog>
    <!-- 曲谱预览 -->
    <el-dialog
      :title="sheetPreviewDialogTitle + '预览'"
      :visible.sync="sheetPreviewDialogVisible"
      width="290px"
    >
      <sheet-preview-dialog
        :music-id="sheetPreviewDialogId"
      ></sheet-preview-dialog>
      <p
        style="
          text-align: center;
          font-size: 14px;
          color: #333;
          margin-top: 12px;
        "
      >
        请使用音乐窝APP扫码预览
      </p>
    </el-dialog>
  </div>
</template>
<script>
import correctDialog from "./correctDialog.vue";
import {
  homeworkDetail,
  correctedList,
  homeworkDel,
  getHomeworkDetailListApi,
  getHomeworkRedoApi,
} from "@/api/homework";
import { dateFormat } from "@/utils/timeFormat";
import audioPlay from "../addAfter/audioPlay.vue";
import sheetPreviewDialog from "../addAfter/sheetPreviewDialog.vue";
export default {
  components: {
    audioPlay,
    correctDialog,
    sheetPreviewDialog,
  },
  data() {
    return {
      searchInfo: {},
      id: 0,
      detailsData: {
        content_list: [],
        be_correct_num: 0,
      }, //总数据
      tableData: [], // 练习明细列表
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 5,
      dialogImageUrl: "",
      dialogVideoUrl: "",
      dialogVisible: false,
      dialogVideo: false,
      correctedListData: [],
      showText: false,
      showPicture: false,
      showMP3: false,
      showMP4: false,
      showSheet: false,
      showFormSearch: true,
      showCorrectDialog: false,
      correctDialogInfo: {},
      statusList: [
        {
          status_id: 1,
          name: "未发布",
        },
        {
          status_id: 2,
          name: "未提交",
        },
        {
          status_id: 3,
          name: "待批改",
        },
        {
          status_id: 4,
          name: "已批改",
        },
        {
          status_id: 5,
          name: "已截止",
        },
      ],
      sheetPreviewDialogVisible: false,
      sheetPreviewDialogId: "",
      sheetPreviewDialogTitle: "",
    };
  },
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    _t.getDetails(_t.id);
    _t.getCorrectedList(_t.id);
    _t.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
    if (_t.$route.query.h_s_id && _t.$route.query.h_id) {
      _t.correct({
        homework_student_id: Number(_t.$route.query.h_s_id),
        homework_id: Number(_t.$route.query.h_id),
        deadline_status: Number(_t.$route.query.ddl_status),
      });
    }
  },
  methods: {
    newOpen(v) {
      window.open(v, "_blank");
    },
    delHomeWork(v) {
      this.$confirm(
        "删除后学员提交的练习也会一起删除，且数据无法恢复，确定要删除吗？",
        `删除 - ${v.title}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          homeworkDel({
            homework_ids: [v.homework_id],
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.$router.go(-1);
            }
          });
        })
        .catch(() => {});
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        pageSize: this.pageSize,
      });
    },
    correct(val) {
      this.showCorrectDialog = true;
      this.correctDialogInfo = val;
    },
    republish(val) {
      this.$confirm(
        `确定将练习再次发布给学员 “${val.student.name}”，让学员可以再次上传练习内容，确定要重新发布？`,
        `重新发布 - ${val.homework.title}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          getHomeworkRedoApi({
            homework_student_id: val.homework_student_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "重发完成",
              });
              this.showCorrectDialog = false;
              this.getList({
                page: this.page,
                pageSize: this.pageSize,
              });
            }
          });
        })
        .catch(() => {});
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        pageSize: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        pageSize: e,
      });
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: this.page,
        pageSize: this.pageSize,
      });
    },
    getList(val) {
      const option = {
        page: val.page,
        page_size: val.pageSize,
        homework_id: this.id,
        include_unpublished: true,
      };
      if (this.searchInfo.status) {
        option.status = this.searchInfo.status;
      }
      if (this.searchInfo.sort_type) {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        option.sort_field = this.searchInfo.sort_field;
      }
      getHomeworkDetailListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((it) => {
            it.committed_time =
              it.committed_time !== 0
                ? dateFormat("YYYY-mm-dd HH:MM", it.committed_time * 1000)
                : "-";
            it.corrected_time =
              it.corrected_time !== 0
                ? dateFormat("YYYY-mm-dd HH:MM", it.corrected_time * 1000)
                : "-";
          });
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    play(e) {
      const _t = this;
      if (e.annex_type == 1) {
        _t.dialogImageUrl = e.annex_content;
        _t.dialogVisible = true;
      } else if (e.annex_type == 2) {
        _t.dialogVideoUrl = e.annex_content;
        _t.dialogVideo = true;
      }
    },
    setTime(a) {
      return dateFormat("YYYY-mm-dd HH:MM", new Date(Number(a + "000")));
    },
    getDetails(id) {
      const _t = this;
      homeworkDetail({ homework_id: id }).then((res) => {
        if (res.error_code == 0) {
          if (res.data.content_list.length > 0) {
            res.data.audioList = res.data.content_list.reduce((a, b) => {
              if (b.annex_type == 4) {
                b.url = b.annex_content;
                a.push(b);
              }
              return a;
            }, []);
          }
          res.data.content_list.map((item) => {
            if (item.annex_type === 1) {
              this.showPicture = true;
            } else if (item.annex_type === 2) {
              this.showMP4 = true;
            } else if (item.annex_type === 3) {
              this.showText = true;
            } else if (item.annex_type === 4) {
              this.showMP3 = true;
            } else if (item.annex_type === 5) {
              this.showSheet = true;
            }
          });
          _t.detailsData = res.data;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    getCorrectedList(id) {
      const _t = this;
      correctedList({ homework_id: id }).then((res) => {
        if (res.error_code == 0) {
          _t.correctedListData = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleSheetPreview(data) {
      this.sheetPreviewDialogId = data.annex_content;
      this.sheetPreviewDialogVisible = true;
      this.sheetPreviewDialogTitle = data.music.name;
    },
  },
};
</script>

<style scoped lang="scss">
.stydyDetails {
  .bigimg {
    max-width: 100%;
    max-height: 80vh;
    margin: 0 auto;
    display: block;
  }
  .selfheader {
    display: flex;
    align-items: center;
  }
  .titlered {
    border-radius: 50%;
    background: #ff2600;
    margin-left: 5px;
    display: inline-block;
    line-height: normal;
    padding: 2px;
    font-size: 12px;
    color: #fff;
    min-width: 10px;
    min-height: 10px;
    line-height: 12px;
  }
  .question {
    width: 15px;
    height: 15px;
    opacity: 1;
    background: #bebfc0;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 10px;
    margin-left: 5px;
  }
  // 弹框
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e7e8ea;
  }
  .btnsize {
    padding: 0 11px;
    line-height: 22px;
    margin-left: 10px;
  }
  .dialogForm {
    display: flex;
    justify-content: space-between;
  }
  .imageText {
    padding: 10px;
    border: 1px solid #e1e5e9;
    border-radius: 4px;
    textarea {
      height: 60px;
      width: 100%;
      resize: none;
      border: 0;
      outline: none;
    }
  }
  .next_follow {
    display: flex;
    .next_follow_left {
      width: 50%;
      height: 60px;
      display: flex;
      align-items: center;
    }
    .next_follow_right {
      width: 50%;
      height: 50px;
      padding-top: 10px;
      display: flex;
      justify-content: flex-end;
      span {
        color: rgba(7, 209, 170, 1);
      }
    }
  }
  /deep/ .el-upload_img {
    .el-upload {
      width: 80px;
      height: 80px;
      line-height: 95px;
    }
  }
  /deep/ .next_follow {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      width: 200px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  // 弹框end
  //页头
  .page_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e7e8ea;
    padding-bottom: 9px;
    background: #fff;
    padding: 13px;
  }
  .page_header_left {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: center;
  }
  .el-icon-back {
    font-size: 18px;
    margin-right: 6px;
    align-self: center;
  }
  .el-icon-back:before {
    content: "\e6ea";
  }
  .page_header_left_back {
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
    position: relative;
  }
  .page_header_left_back::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #dcdfe6;
  }
  .page_header_content {
    font-size: 13px;
    font-weight: bold;
    color: #5c5d5e;
  }
  .page_header_control {
    display: flex;
    div:nth-of-type(2) {
      margin: 0 10px;
    }
  }
  //end
  .page_content {
    padding-top: 22px;
    background: #fff;
    padding: 13px;
    .contertTop {
      border-bottom: 1px solid #e7e8ea;
      padding-bottom: 20px;
      .conterDetails {
        margin-top: 20px;
      }
      h1 {
        font-size: 14px;
      }
      .contentNmne {
        font-size: 12px;
        color: #5c5d5e;
      }
    }
  }
  // end
  // 评论盒子
  .contertBottom {
    display: flex;
    flex-wrap: wrap;
    padding-top: 18px;
    .center {
      color: #5c5d5e;
      margin-bottom: 18px;
      font-size: 12px;
      width: 100%;
    }
    .imgVideo {
      display: flex;
      margin-bottom: 16px;
      margin-right: 16px;
      .imgbox,
      .videobox {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        border: 1px solid #e1e5e9;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
        video {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
        .close {
          position: absolute;
          right: 3px;
          top: 3px;
          font-size: 16px;
          color: #d8d8d8;
          cursor: pointer;
          z-index: 2;
        }
        .big {
          font-size: 20px;
          cursor: pointer;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          display: none;
          border-radius: 4px;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
    .imgbox:hover .big,
    .videobox:hover .big {
      display: flex;
    }
  }
  .audiobox {
    display: flex;
    padding-top: 18px;
    flex-wrap: wrap;
    .audiosmbox {
      width: 250px;
    }
  }
  .page_footer {
    margin-top: 12px;
    min-height: 383px;
    background: #fff;
    padding: 13px;
    h1 {
      font-size: 14px;
    }
    .page_content_avatar {
      border-radius: 50%;
      border: 1px solid #e7e8ea;
    }
    .editBtn {
      color: #07d1aa;
    }
    .closeBtn {
      color: #ffb940;
    }
    .delBtn {
      color: #5c5d5e;
    }
    .red {
      color: #f56c6c;
    }
    .green {
      color: #07d1aa;
    }
  }
}
.practice-classification {
  display: flex;
  .title {
    padding-top: 18px;
    font-size: 14px;
    font-weight: 600;
    padding-left: 10px;
    min-width: 50px;
  }
  .contertBottom-right {
    flex: 1;
  }
}
.time-line-switch {
  position: absolute;
  top: 38px;
  right: 2px;
  .p4 {
    padding: 8px;
    font-size: 12px;
    cursor: pointer;
    color: #5c5d5e;
    span {
      font-size: 14px;
      color: #c0c4cc;
      margin-left: 4px;
    }
  }
}
.page {
  height: 50px;
}
.xing-xing {
  display: flex;
  font-size: 14px;
  padding: 20px 0;
  border-bottom: 1px solid #d7d7d7;
}
.bottom-btn {
  display: flex;
  justify-content: flex-end;
  div {
    margin: 10px 10px;
  }
}
.studentPracticeDetail {
  padding: 15px;
  .info {
    padding-bottom: 10px;
    border-bottom: 3px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    .info-left {
      .title {
        font-size: 16px;
        margin-bottom: 15px;
      }
      .head-sculpture {
        display: flex;
        height: 62px;
        .head {
          min-width: 60px;
          min-height: 60px;
          overflow: hidden;
          border-radius: 50%;
          border: 1px solid #cdcdcd;
          margin: 0 20px 0 10px;
          img {
            width: 60px;
            height: 60px;
          }
        }
        :nth-child(2) {
          flex: 1;
          .name {
            display: block;
            font-size: 14px;
            line-height: 30px;
            white-space: nowrap;
            span {
              font-size: 12px;
              top: -1px;
              position: relative;
            }
          }
        }
      }
    }
    .info-right {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      text-align: center;
      line-height: 70px;
      font-size: 14px;
      color: #ffffff;
    }
    .bgc1 {
      background-color: #ff9522;
    }
    .bgc2 {
      background-color: #07d1aa;
    }
  }
  .comment-detail {
    border-bottom: 3px solid #f2f2f2;
    .title {
      margin-top: 15px;
      font-size: 16px;
      margin-bottom: 15px;
    }
    .comment-in {
      width: 100%;
      padding: 10px;
      display: flex;
      align-items: flex-start;
      .name {
        font-size: 14px;
        margin-right: 10px;
        width: 65px;
      }
      .information {
        flex: 1;
        white-space: pre-wrap;
        font-size: 14px;
        width: 200px;
      }
    }
    :nth-child(2) {
      padding-top: 0;
    }
  }
  .content {
    .title {
      padding-top: 10px;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .contCopy {
      font-size: 14px;
    }
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
/deep/ .el-textarea__inner {
  width: 550px;
  min-height: 100px !important;
}
/deep/ .el-select {
  overflow: hidden;
  height: 30px !important;
  .el-select__tags {
    width: 100%;
    display: flex;
    max-width: 161px;
    flex-wrap: nowrap;
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 4px;
      height: 1px;
    }
    &::-webkit-scrollbar-track {
      width: 4px;
      background: none;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      background: #d8d8d8;
      border-radius: 2px;
    }
  }
}
.opernbox {
  width: 320px;
  display: block;
  position: relative;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #e1e5e9;
  margin-right: 16px;
  margin-bottom: 16px;
  .flex {
    display: flex;
  }
  .close {
    font-size: 16px;
    color: #d8d8d8;
    cursor: pointer;
  }
  .opern-title {
    margin: 14px 13px;
    line-height: 2;
    .title-text {
      flex: 1;
      font-size: 12px;
      color: #5c5d5e;
    }
    .close {
      top: 12px;
      right: 10px;
    }
  }
  .opern-content {
    margin: 10px 13px;
    font-size: 12px;
    color: #adaeae;
    .content-info {
      flex: 1;
    }
    .content-border {
      border-right: 1px solid #adaeae;
      margin: 0 10px;
      height: 12px;
    }
    .content-view {
      position: absolute;
      top: 14px;
      right: 20px;
      padding: 0 8px;
      border-radius: 6px;
      border: 1px solid #45b13b;
      color: #45b13b;
      cursor: pointer;
      margin-left: 10px;
      background-color: #f3fdfa;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>
